import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../State";
import "../combinedplan.css";

import ContentBoxMUI from "../../../Components/ContentBoxMUI";
import ChildRow from "../../Vasu/ChildRow";
import LearningAreaDetail from "./LearningAreaDetail";
import { getProfilePictureData } from "../../../utils";
import { getCombinedPlanSectionTitle } from "../sectionTitles";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const LearningAreasPart = (props) => {
  const { state } = useStateValue();
  const combinedPlanData = state.combinedPlan.data;
  const LearningAreas = combinedPlanData ? combinedPlanData.LearningAreas : [];
  const prepStatus = combinedPlanData?.PreparationSectionStatus;

  const { history, match } = props;
  const childId = match.params.ChildId;
  const child = state.children?.ChildList?.find((c) => c.Id === childId);
  const childpicture = getProfilePictureData(state, child?.Id);
  const childFirstName = child?.FirstName ?? null;
  const childLastName = child?.LastName ?? null;
  const childColor = child?.BgColor ?? null;
  const sectionTitle = getCombinedPlanSectionTitle(
    combinedPlanData,
    "learningAreas",
    combinedPlanData?.LearningAreasSectionTitle,
  );

  const [ShowSlideIndex, setShowSlideIndex] = useState(-1);

  useEffect(() => {
    if (!combinedPlanData) {
      history.replace(`/combinedplan/${childId}`);
    }
  }, []);

  const handleBackClick = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      setShowSlideIndex(-1);
      window.onpopstate = undefined;
      window.history.back();
    };
  };

  const handleBoxClick = (index) => {
    setShowSlideIndex(index);
    handleBackClick();
  };

  if (!combinedPlanData) {
    return <div className="CombinedPlanContainer"></div>;
  }

  // Backend returns areas in correct display order (hardcoded 0-4, then custom questions)
  // Do NOT re-sort — custom questions may share SortOrder values with hardcoded areas
  const sortedAreas = LearningAreas;

  return (
    <div className="CombinedPlanContainer">
      <ContentBoxMUI>
        <Box sx={{ mt: 1 }}>
          <ChildRow
            childpicture={childpicture}
            childFirstName={childFirstName}
            childLastName={childLastName}
            childColor={childColor}
            FormId={combinedPlanData.PlanId}
            history={history}
          />
        </Box>

        {ShowSlideIndex === -1 ? (
          <div>
            {sortedAreas.length === 0 ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 2, ml: 1 }}
              >
                Ei oppimisalueita.
              </Typography>
            ) : (
              <List className="col-12" sx={{ mt: 1 }}>
                {sortedAreas.map((area, index) => (
                  <ListItemButton
                    key={index}
                    className="boxed"
                    sx={{
                      backgroundColor: "#a6dee0",
                      borderRadius: 0.5,
                      mt: 1.5,
                      boxShadow: 2,
                    }}
                    onClick={() => handleBoxClick(index)}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontWeight: "Bold",
                        fontSize: 16,
                        ml: 2,
                      }}
                      primary={area.Title}
                    />
                    <ListItemIcon>
                      <ArrowForwardIosIcon fontWeight="Bold" fontSize="small" />
                    </ListItemIcon>
                  </ListItemButton>
                ))}
              </List>
            )}
          </div>
        ) : (
          <LearningAreaDetail
            SelectedSlideIndex={ShowSlideIndex}
            sortedAreas={sortedAreas}
            sectionTitle={sectionTitle}
          />
        )}
      </ContentBoxMUI>
    </div>
  );
};

export default LearningAreasPart;
